"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.razorpayReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const razorpayAction_1 = require("./razorpayAction");
const initialState = {
    loading: false,
    error: null,
    data: [],
};
const razorpaySlice = (0, toolkit_1.createSlice)({
    name: "razorpay/create",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(razorpayAction_1.create.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(razorpayAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(razorpayAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.razorpayReducer = razorpaySlice.reducer;
